// 検索一致箇所のハイライト表示

export function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

// <mark> の共通スタイル（Markdown 内のハイライトと揃える）
export const MARK_CLASS = 'bg-yellow-200 text-inherit rounded-sm'

// text 中の query 一致箇所（大文字小文字を区別しない）を <mark> で囲んで表示する
export default function Highlight({
  text,
  query,
}: {
  text: string
  query?: string
}) {
  const q = query?.trim()
  if (!q) return <>{text}</>
  // キャプチャ付き split により奇数インデックスが一致部分になる
  const parts = text.split(new RegExp(`(${escapeRegExp(q)})`, 'ig'))
  if (parts.length === 1) return <>{text}</>
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <mark key={i} className={MARK_CLASS}>
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </>
  )
}
